export const endpoints = {
  new_refills: 'NuevaRecarga',
  balance_dicount: 'DescuentoSaldo',
  employee_list: 'ListaEmpleados',
  employee_list_lite: 'ListaEmpleados_Lite',
  change_employee_status: 'CambioEstadoEmpleados',
  create_account: 'CreacionCuenta',
  create_nn_account: 'CreacionCuentaNN',
  branch_office: 'ListaSucursal',
  cost_center: 'ListaCentroCosto',
  company_employees: 'EmpleadosEmpresa',
  calculate_recharge: 'CalculoRecargaIndividual',
  listCompanyData: 'ListaSCG',
  asignNN: 'AsignacionCuentaNN',
  login: 'LoginEmpresa',
  rechargeList: 'ListadoRecargas',
  listNN: 'ListadoCuentasNN',
  cards: 'InfoDashboard',
  foodCategories: 'GraficoCatDashBoard',
  refillDetail: 'DetalleRecarga',
  dashboardConsumption: 'GraficoConsumoDashBoard',
  securityPin: 'EnvioPinSeguridad',
  editEmpoyee: 'EditarEmpleado',
  accountsRequested: 'CuentasSolicitadas',
  employeeDetails: 'DetalleEmpleado',
  companyDetail: 'DetalleEmpresa',
  authorize: 'LoginUsuarioEmpresa',
  nnReports: 'ReporteTarjetasNN',
  nnReportsExport: 'export/ReporteTarjetasNN',
  companyConsumptionReport: 'ReporteEmpresaConsumo',
  companyConsumptionExport: 'export/ReporteEmpresaConsumo',
  dailyEmployeeRefills: 'ReporteRecargaDiariaEmpleado',
  dailyEmployeeRefillsExport: 'export/ReporteRecargaDiariaEmpleado',
  ocReport: 'ReporteOCEmpresa',
  ocExport: 'export/ReporteOCEmpresa',
  rechargesToBill: 'RecargasPorFacturar',
  historyMovements: 'MovimientosHistoricos',
  purchaseOrders: 'DetalleOrdenesCompra',
  historicMovement: 'DetalleMovHistorico',
  listBranchOffice: 'ListarSucursales',
  branchOfficeDetail: 'DetalleSucursal',
  listCostCenters: 'ListarCentroCosto',
  createBranchOffice: 'CrearSucursal',
  createMassiveBranchOffice: 'CargaMasivaSucursales',
  regions: 'RegionesComunas',
  infoOC: 'InfoOrdenCompra',
  newCostCenter: 'CargaCentroCosto',
  confirmRefill: 'ConfirmaRecarga',
  declineRefill: 'EliminarRecarga',
  changePass: 'CambioContrasenaEmpresa',
  pendingRefills: 'ListadoRecargasProgramadas',
  validateCompanyData: 'ValidarInfoEmpresa',
  validateMassiveNominative: 'ValidaArchivoRecargaMasivaNominativa',
  noNominativeRefillFile: 'ReporteDescargaArchivoRecargaNN',
  topEcoFriendly: 'TopLocalesEcoFriendly',
  topLocalesBarrio: 'TopLocalesBarrio',
  promotions: 'promotions',
  digitalTransactions: 'TransaccionesDigitales',
  updateBranchOffice: 'EditarSucursal',
  updateCostCenter: 'EditarCentroCosto',
  costCenterDetail: 'DetalleCentroCosto',
  deleteCostCenter: 'EliminaCentroCosto',
  deleteBranchOffice: 'EliminaSucursal',
  validateMassiveTermination: 'ValidacionArchivoDV',
  massiveTermination: 'DesvinculacionMasiva',
  contactsDetails: 'DetalleContactoInterlocutor',
  inactiveUserList: 'ListaUsuariosInactivos',
  editManager: 'EditarContactoInterlocutor',
  defaultAlerts: 'InfoAlertasBase',
  activeAlerts: 'InfoAlertasEmpresa',
  configureAlert: 'CreaAlertaEmpresa',
  AjustesWebEmpresa: 'AjustesWebEmpresa',
  getAutomaticEnroll: 'ConsultaAjusteEnrolamientoNN',
  refillReport: 'ReporteDetalleRecargaSucursal',
  casinoReport: 'ReporteConsumoCasino',
  casinoReportInfo: 'InfoConsumoCasino',
  denyReasign: 'RechazarReasignacion',
  approveReasign: 'AceptarReasignacionBolsillo',
  approveAssign: 'AceptarAsignacionBolsillo',
  denyEnrolment: 'RechazarEnrolar',
  changeAlertState: 'CambioEstadoAlertaEmpresa',
  empresaNuevoPortal: 'EmpresaNuevoPortal',
  refreshToken: 'RefreshToken',
  verifyPasswordChange: 'VerifyPasswordChange',
  ReSendCodLoginEmpresa: 'ReSendCodLoginEmpresa',
  VerifyCodLoginEmpresa: 'VerifyCodLoginEmpresa',
  VerifyPasswordChange_Modal: 'VerifyPasswordChange_Modal',
  CambioContrasenaEmpresa_PrimerLogin: 'CambioContrasenaEmpresa_PrimerLogin',
  listadoColaboradoresReporte: 'ReporteListadoColaboradores',
  recargaColaboradoresReporte: 'ReporteRecargaColaboradores',
  listadoColaboradoresExport: 'export/ReporteListadoColaboradores',
  recargaColaboradoresExport: 'export/ReporteRecargaColaboradores',
  SendEmailAdvisorCompany: 'EnvioEmailAsesorEmpresa',
  NewLocales: 'NewLocales',
  SolicitudContactoGiftCard: 'SolicitudContactoGiftCard',
  IndicadorDigitalizacion: 'IndicadorDigitalizacion',
  SolicitudContactoDigital: 'SolicitudContactoDigital',
  EmpresaSolicitudComercio: 'EmpresaSolicitudComercio',
  EmpresaSolicitudEmpresa: 'EmpresaSolicitudEmpresa',
  SolicitudContactoSalaCuna: 'SolicitudContactoSalaCuna',
  surveyDefinicion: 'Survey/Definicion',
  surveyEstado: 'Survey/Estado',
  surveyRegistrar: 'Survey/Registrar',
  surveySeleccionar: 'Survey/Seleccionar',
  reporteRecargaAutomatica: 'ReporteRecargaAutomatica',
  listaContactosEmpresa: 'ListaContactosEmpresa',
  listaLogContactos: 'ListaLogContactos',
}

export const localStorageKeys = {
  companyData: 'companyData',
  currentUser: 'currentUser',
  regions: 'regions',
}
